/*
  * @Author: zql
  * @Date: 2025/1/20 15:01
* */

const state = {
    clear_conditions_kpi: false,
    update_conditions_kpi: false,
};

const mutations = {
    CLEAR_CONDITIONS_KPI:(state) => {
        state.clear_conditions_kpi = !state.clear_conditions_kpi;
    },
    UPDATE_CONDITIONS_KPI:(state) => {
        state.update_conditions_kpi = !state.update_conditions_kpi;
    },
};


export default {
    namespaced: true,
    state,
    mutations,
}

